import React from 'react';

import { Card, Button, Container } from 'react-bootstrap';
import styles from './RequestPayment.module.scss';
import { Link, Redirect } from 'react-router-dom';
import Image from '../../core-components/Image/Image';
import AppConstants from '../../../../../core-components/AppConstants';

export default function SuccessPaymentRequest() {
  const proformaInvoice = new URLSearchParams(document.location.search).get('proforma_number');
  const orderId = new URLSearchParams(document.location.search).get('order_id');

  if (!proformaInvoice && !orderId) {
    return (
      <Redirect
        to={{
          pathname: '/transaction'
        }}
      />
    );
  }
  const handleBuyBtn = () => {
    window.open(`${AppConstants.baseURL}orderDetails?order_id=${orderId}`, '_blank');
  };
  const handleViewDetails = () => {
    window.open(`${AppConstants.baseURL}balance`, '_self');
  };

  return (
    <Card className={`text-center ${styles.card}`}>
      <Card.Body className={`${styles.body}`}>
        <Image name={'orderSent.svg'} isSA={false} className={styles.image} />
        <Card.Title className={styles.title}>{'Order Created & Sent'}</Card.Title>
        <Card.Text className='m-3'>
          If you have used your credit balance for this order, these credits will be locked till
          this order is active.
        </Card.Text>
        <Card.Text className={styles.referenceText}>Reference Number: {proformaInvoice}</Card.Text>
        <Container className={styles.btnContainer}>
          <Button onClick={handleBuyBtn} variant='primary'>
            View details
          </Button>
          <Button onClick={handleViewDetails} variant='outline-primary'>
            Balances/Buy
          </Button>
        </Container>
        <Card.Text className={styles.help}>
          <small className={`text-muted`}>
            Need help ?{' '}
            <span
              className={styles.contactUs}
              onClick={() => window.open('mailto:cs@springverify.com', '_blank')}
            >
              Contact us
            </span>
          </small>
        </Card.Text>
      </Card.Body>
    </Card>
  );
}
